var exports = {
  "Mv": "TextareaButtons.module__invisibleTrigger___eUFNU2",
  "IO": "TextareaButtons.module__mobileRightButtonContainer___eUFNU2",
  "Pc": "TextareaButtons.module__mobileRightButtonSlot___eUFNU2",
};

module.exports = exports;
